import { useTranslation } from "react-i18next";
import type { EventType } from "types";
import CrudEdit from "common/components/Crud/CrudEdit";
import { TableColumn } from "common/components/DataTable/DataTable";
import { CrudHeaderAction } from "common/components/Crud/components/CrudHeader";
import { CrudFilter } from "common/components/Crud/components/CrudFilters";
import CrudList from "common/components/Crud/CrudList";
import { useMemo } from "react";
import EventTypeForm from "./EventTypeForm";

function SidebarEventTypeForm({ ...props }: any) {
  return (
    <CrudEdit collectionName="event-types" Form={EventTypeForm} {...props} />
  );
}

function EventTypes() {
  const { t } = useTranslation();

  const columns: TableColumn<EventType>[] = useMemo(
    () => [
      {
        field: "name",
        header: t("event-types.name"),
        sortable: true,
        renderType: "bold",
      },
      {
        field: "color",
        header: t("event-types.color"),
        renderType: "color",
      },
    ],
    [t],
  );

  const actions: CrudHeaderAction[] = useMemo(() => {
    return [
      {
        title: t("common.new"),
        icon: "PlusCircleIconSolid",
        action: "openSidebar",
        type: "white",
        className: "flex flex-row-reverse",
      },
    ];
  }, [t]);

  const filters: CrudFilter[] = useMemo(() => {
    return [
      {
        name: "name$containsi",
        label: t("event-types.name"),
        renderType: "input",
        icon: "MagnifyingGlassIcon",
      },
    ];
  }, [t]);

  return (
    <CrudList
      collectionName="event-types"
      columns={columns}
      headerActions={actions}
      filters={filters}
      defaultSort="name:ASC"
      canDelete
      canEdit
      formMode="sidebar"
      SidebarFormComponent={SidebarEventTypeForm}
      actionsHeader=""
      className="pt-2 px-4"
    />
  );
}

export default EventTypes;
